'use client'
import { useEditedGif } from '@/context/edit-manager'
import { cn } from '@/util/cn'
import { IGif } from '@giphy/js-types'
import { setGADataLayer } from 'analytics'
import Link from 'next/link'
import { useState } from 'react'
const pillClassName =
    'bg-gradient-grey flex shrink-0 cursor-pointer flex-nowrap gap-px rounded-3xl px-4 py-3.5 items-center'
type Props = { gif: IGif }
const maxCharacters = 80
const useTags = (gif: IGif) => {
    gif = useEditedGif(gif.id) || gif
    const [showMore, setShowMore] = useState(false)
    let needsShowMore = false
    let chars = 0
    let truncateTagsAtIndex
    let tags = gif.tags?.filter((tag) => {
        return !tag.startsWith('giphy') && tag !== 'transparent'
    })
    tags.some((tag, index) => {
        chars += tag.length + 5 // add 5 for the space between tags
        if (chars > maxCharacters) {
            truncateTagsAtIndex = index
            needsShowMore = true
            return true
        }
    })
    tags = showMore ? tags : [...tags].slice(0, truncateTagsAtIndex)
    return { tags, needsShowMore, showMore, setShowMore }
}

const Tags = ({ gif }: Props) => {
    const { tags, needsShowMore, showMore, setShowMore } = useTags(gif)
    return (
        <div className="mb-5 flex gap-1.5">
            <div className={`group flex flex-wrap gap-1.5`}>
                {tags.map((tag) => (
                    <Link
                        href={`/explore/${encodeURIComponent(tag.replace(/ /g, '-'))}`}
                        key={tag}
                        className={cn(
                            pillClassName,
                            'transition-opacity duration-200',
                            'group-hover:not-[&:hover]:opacity-50'
                        )}
                        onClick={() => {
                            setGADataLayer({
                                event: 'search',
                                options: {
                                    searchType: 'detail-tags',
                                    searchTerm: tag,
                                },
                            })
                        }}
                    >
                        <span className="text-giphyLightGrey translate-y-px">#</span>
                        <span className="font-bold">{tag}</span>
                    </Link>
                ))}
                {needsShowMore && !showMore ? (
                    <div onClick={() => setShowMore(true)}>
                        <div className={cn(pillClassName, 'cursor-pointer')}>...</div>
                    </div>
                ) : null}
            </div>
        </div>
    )
}
export default Tags
